import LegalLayout from "@/components/LegalLayout";

export default function Yritystiedot() {
  return (
    <LegalLayout title="Yritystiedot">
      <p>
        Lahden Autokulma (Tepe Markkinointi Oy) on lahtelainen käytettyjen
        autojen erikoisliike. Alla viralliset yritys- ja yhteystiedot.
      </p>
      <div>
        <h2>Yritys</h2>
        <ul>
          <li>Virallinen nimi: Tepe Markkinointi Oy</li>
          <li>Aputoiminimi: Lahden Autokulma</li>
          <li>Y-tunnus: 1557725-9</li>
          <li>ALV-tunnus: FI15577259</li>
          <li>Yhtiömuoto: Osakeyhtiö (perustettu 1999)</li>
          <li>Kotipaikka: Lahti</li>
        </ul>
      </div>
      <div>
        <h2>Yhteystiedot</h2>
        <ul>
          <li>Osoite: Äijälänkatu 3, 15700 Lahti</li>
          <li>Puhelin: 03 782 4041</li>
          <li>Ville Paakkari: 044 354 9300 · ville.paakkari@lahdenautokulma.fi</li>
          <li>Teijo Paakkari: 0500 653 999 · teijo.paakkari@lahdenautokulma.fi</li>
        </ul>
      </div>
      <div>
        <h2>Aukioloajat</h2>
        <ul>
          <li>Ma–Pe 10–18</li>
          <li>La 10–14</li>
          <li>Su suljettu</li>
        </ul>
      </div>
    </LegalLayout>
  );
}
